/**
 * A small status label: "Bereit", "Läuft", "Fehlgeschlagen", a Rubrik, a count.
 * The tone carries the meaning; the text always says it too.
 */

import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from './styles'

export type BadgeTone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info'

const TONE: Record<BadgeTone, string> = {
    neutral: 'bg-surface-sunken text-fg-secondary',
    primary: 'bg-primary-soft text-primary',
    success: 'bg-success-soft text-success',
    warning: 'bg-warning-soft text-warning',
    danger: 'bg-danger-soft text-danger',
    info: 'bg-info-soft text-info',
}

export default function Badge({
    tone = 'neutral',
    icon: Icon,
    className,
    children,
}: {
    tone?: BadgeTone
    icon?: LucideIcon
    className?: string
    children: ReactNode
}) {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold',
                TONE[tone],
                className,
            )}
        >
            {Icon && <Icon className="h-3.5 w-3.5" aria-hidden="true" />}
            {children}
        </span>
    )
}
